import { BlockerFunction } from "@remix-run/router";
import React, { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import { IToast } from "../../features/notifications/definitions";
import { useNotifications } from "../../features/notifications/hooks";

export const saveYourChangesToastMessage: Partial<IToast> = {
    message: "Please save or cancel your current changes before proceeding.",
    type: "warning",
    timeout: 10000,
};

export function usePreventWindowUnload(
    unloadConditionRef,

    callbackFunction?: () => void
) {
    const { addToast } = useNotifications();

    useEffect(() => {
        const handleBeforeUnload = async unloadEvent => {
            if (unloadConditionRef.current?.preventUnload && callbackFunction) {
                callbackFunction();

                //Some browsers require a return value
                unloadEvent.returnValue = saveYourChangesToastMessage.message;
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const shouldBlock = React.useCallback<BlockerFunction>(({ currentLocation, nextLocation }) => {
        return (
            unloadConditionRef.current?.blockNavigation &&
            currentLocation.pathname !== nextLocation.pathname
        );
    }, []);

    const blocker = useBlocker(shouldBlock);
    React.useEffect(() => {
        if (blocker.state === "blocked") {
            addToast(saveYourChangesToastMessage);
            blocker.reset();
        }
    }, [blocker]);
}
